export const clear = {
    name: "clear",
    description: "Clears terminal screen",
    run: () => "__CLEAR__"
};